import { Query } from '@/lib/generated/graphql-types'

import { GET_USER_PROFILE } from '@/modules/user/profile/queries'
import { useQuery } from '@apollo/client'

export function useSurveySubmissionStatus({
  isAuthenticated,
}: {
  isAuthenticated: boolean
}) {
  const { data: userProfileData } = useQuery<Pick<Query, 'getUserProfile'>>(
    GET_USER_PROFILE,
    {
      skip: !isAuthenticated,
    },
  )

  return {
    isOnboardingComplete: Boolean(userProfileData?.getUserProfile?.onboardedAt),
  }
}
